import { t } from "@/i18n-js/instance";
import { useSelectedBlock } from "@circle-react-shared/BuilderUI";
import type { TitleMdProps } from "@circle-react-shared/uikit/Typography/components/Title/TitleMd";
import { Typography } from "@circle-react-uikit/Typography";

export const SidebarHeaderTitle = ({ children, ...rest }: TitleMdProps) => {
  const { meta } = useSelectedBlock();

  return (
    <div className="py-0.5">
      <Typography.LabelMd weight="semibold" {...rest}>
        <span className="leading-7">
          {children ||
            t(String(meta?.nameI18n), {
              defaultValue: meta?.name || t("builder_ui.example.editor_title"),
            })}
        </span>
      </Typography.LabelMd>
    </div>
  );
};
